import React from 'react';

const ActivityDetailContent = ({ data }) => <div></div>;

export default ActivityDetailContent;
